<template>
    <div>

        <section class="rules">
            <rules-text></rules-text>
        </section>

    </div>
</template>

<script>
export default {
    name: 'rules',
    data () {
        return {
        }
    },
    methods: {
    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/app.scss';

    .rules {
        padding: 50px 0;
    }
</style>
